import { TEAM_CUSTOM_ACTION_EVENT_TRIGGERS } from '@/utils/CustomActionConstants';

import { store } from '@/store/store';

const mapCustomerIds = (customerIds) => {
    const customerList = store.getters['team/customers'];

    if (!customerList || !customerList.length || !customerIds) 
        return '-';

    const arrCustomerIds = JSON.parse(customerIds);
    if (!Array.isArray(arrCustomerIds)) 
        return '-';

    const customerNames = customerList.filter((x) => arrCustomerIds.some((k) => k === +x.key)).map((x) => x.value);

    return customerNames.join(', ');
};

const mapTeamRegionIds = (teamRegionIds) => {
    const teamRegionList = store.getters['team/teamRegions'];

    if (!teamRegionList || !teamRegionList.length || !teamRegionIds) 
        return '-';

    const arrTeamRegions = JSON.parse(teamRegionIds);
    if (!Array.isArray(arrTeamRegions)) 
        return '-';

    const teamRegionNames = teamRegionList
        .filter((x) => arrTeamRegions.some((k) => k === x.teamRegionId))
        .map((x) => x.name);

    return teamRegionNames.join(', ');
};

const getStopCustomFieldsLabel = (variableKey) => {
    const user = store.getters['user/user'];
    const stopCustomFieldList = user.stopCustomFieldDefinitions;

    const cf = stopCustomFieldList.find((x) => x.name === variableKey);
    return cf?.label ?? variableKey;
};

const getShipmentCustomFieldsLabel = (variableKey) => {
    const user = store.getters['user/user'];
    const shipmentCustomFieldList = user.shipmentCustomFieldDefinitions;

    const cf = shipmentCustomFieldList.find((x) => x.name === variableKey);
    return cf?.label ?? variableKey;
};

const toOperatorDesc = (subCond) => {
    switch (subCond.operator) {
        case '==':
        case 'In':
            return 'equals';
        default:
            return subCond.operator.toLowerCase();
    }
};

const getEventTrigger = (eventTrigger) => {
    return TEAM_CUSTOM_ACTION_EVENT_TRIGGERS.find((x) => x.eventTrigger === eventTrigger);
};

const allowedConditions = (eventTrigger, action) => {
    const currentEventTrigger = getEventTrigger(eventTrigger);

    if (
        action === 'Email' &&
        currentEventTrigger?.emailConfig?.allowedConditions &&
        currentEventTrigger.emailConfig.allowedConditions.length
    ) {
        return [...currentEventTrigger.emailConfig.allowedConditions];
    }

    if (
        action === 'Sms' &&
        currentEventTrigger?.smsConfig?.allowedConditions &&
        currentEventTrigger.smsConfig.allowedConditions.length
    ) {
        return [...currentEventTrigger.smsConfig.allowedConditions];
    }

    return [];
};

const describeConditions = (customAction) => {
    if (!customAction?.settings?.conditions || !customAction.settings.conditions.length) 
        return [];

    const conditionDescList = [];

    customAction.settings.conditions.forEach((cond) => {
        cond.subConditions.forEach((subCond) => {
            if (subCond.variable === 'CustomerId') {
                const customerNames = mapCustomerIds(subCond.value);
                conditionDescList.push({
                    variable: 'Customer/s',
                    operator: toOperatorDesc(subCond),
                    value: customerNames
                });
            }

            if (subCond.variable === 'TeamRegionId') {
                const teamRegionNames = mapTeamRegionIds(subCond.value);
                conditionDescList.push({
                    variable: 'Team Region/s',
                    operator: toOperatorDesc(subCond),
                    value: teamRegionNames
                });
            }

            if (subCond.parentObject === 'CustomFields') {
                let label = '';
                const allowedConditionList = allowedConditions(customAction.eventTrigger, customAction.action);

                if (allowedConditionList.some((x) => x === 'StopCustomFields')) {
                    label = getStopCustomFieldsLabel(subCond.variable);
                } else if (allowedConditionList.some((x) => x === 'ShipmentCustomFields')) {
                    label = getShipmentCustomFieldsLabel(subCond.variable);
                }

                conditionDescList.push({
                    variable: label ?? subCond.variable, // todo: map to Desc
                    operator: toOperatorDesc(subCond),
                    value: subCond.operator !== 'Between' ? subCond.value : `${subCond.value} and ${subCond.value2}`
                });
            }
        });
    });

    return conditionDescList;
};

export default {
    describeConditions
};
